import { useState, useEffect } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";

import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';

import { useTranslation } from "react-i18next";
import { getTimestampToDate, parseLocaleDatetime } from "../../../common/util";
import { PodImageData } from "./PodImageData";

interface ArgsType {
    containerImageId: string;
    containerImageName: string;
    containerImageDesc: string;
    containerImageVersion: string;
    pullPath: string;
    imagePath: string;
    projectName: string;
    createDate: string;
    updateDate: string;
}

interface PodImagesUpdateProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
    args?: PodImageData,
};

PodImagesUpdate.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function PodImagesUpdate(props:PodImagesUpdateProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);

    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);


    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            // 창 닫기
            executeResult({successYn: true }, true, "");
        }
    }, [props.clickedConfirmYn]);



    function executeResult(result, closeYn, infoMessage) {
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }

    return (
        <View>
            {
                stepIndex === 0 ?
                // 이름, 설명, 사용 유형, 사용 대상
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("POD_IMAGE_UPDATE_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <View style={{flexDirection: "row", alignItems: "center", justifyContent: "flex-end"}}>
                        <View style={{flexDirection: "row", alignItems: "center"}}>
                            <Text style={style.dateTitleText}>
                                {t("LAST_UPDATE_DATE_TEXT")}
                            </Text>
                            <Text style={style.dateText}>
                                {props.args?.update_ts ? parseLocaleDatetime(props.args?.update_ts) : ""}
                            </Text>
                        </View>
                        <View style={{flexDirection: "row", alignItems: "center", marginLeft: 30,}}>
                            <Text style={style.dateTitleText}>
                                {t("CREATE_DATE_TEXT")}
                            </Text>
                            <Text style={style.dateText}>
                            {props.args?.create_ts ? parseLocaleDatetime(props.args?.create_ts) : ""}
                            </Text>
                        </View>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("NAME_TEXT")}
                            </Text>
                            <Text style={style.dataText}>
                                {props.args?.container_image_name}
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("DESCRIPTION_TEXT")}
                            </Text>
                            <Text style={style.dataText}>
                                {props.args?.container_image_description}
                            </Text>
                        </View>
                        <View style={style.rowDivContainer}/>
                    </View>
                    <Text style={style.titleText}>{
                        t("DETAIL_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("IMAGE_VERSION_TEXT")}
                            </Text>
                            <Text style={{...style.dataText, color: "#3a8344"}}>
                                {props.args?.container_image_version}
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("POD_IMAGE_USING_ENDPOINT_TEXT")}
                            </Text>
                            <Text style={{...style.dataText, color: "#7066f1"}}>
                                {props.args?.image_path}
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("POD_IMAGE_PULL_ENDPOINT_TEXT")}
                            </Text>
                            <Text style={{...style.dataText, color: "#7066f1"}}>
                                {props.args?.pull_path}
                            </Text>
                        </View>
                    </View>
                </View>
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",
    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    dataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    infoText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#8c8c8c"
    },
    dateTitleText: {
        fontFamily: FONT.REGULAR,
        fontSize: 10,
        color: "#8793a3"
    },
    dateText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#9ea0a5"
    },

});